/* eslint-disable */

function stickySidebar() {
    const sidebar = document.querySelector('.sidebar');
    const el_top = sidebar.querySelector('.top');
    const el_bottom = sidebar.querySelector('.bottom');
    if(!el_bottom) return;
    let top = el_top.clientHeight;
    let bottom = el_bottom.clientHeight;
    let inc = 0;

    const setVar = () => {
        top = el_top.clientHeight;
        bottom = el_bottom.clientHeight;
        sidebar.style.setProperty('--bottom', bottom + "px");
        sidebar.style.setProperty('--top', top + "px");
    }

    const onresize = () => {
        inc++;
        if (inc > 20) {
            inc = 0;
            setVar();
        }
    }

    window.addEventListener('resize', onresize, false);

    setVar();
};

export default stickySidebar;